import Rx from 'rxjs/Rx'

export function makeOtherDetails(details) {
  return {
    currency: details.currency,
    verifiedAt: details.verified_at
  };
}

class AcrewardsStore {
  constructor(AcrewardsApiService, CustomerApiService, DashboardApiService, SessionService, ProfileApiService) {
    'ngInject';

    this.AcrewardsApiService = AcrewardsApiService;
    this.CustomerApiService = CustomerApiService;
    this.DashboardApiService = DashboardApiService;
    this.SessionService = SessionService;
    this.ProfileApiService = ProfileApiService;
    this.currency$ = SessionService.session.map(session => session ? session.currency : {});
  }

  getProfile() {
    return this.ProfileApiService.profile();
  }

  getDashboardDetails() {
    return this.DashboardApiService.dashboard().then((details) => {
      return {
        others: makeOtherDetails(details),
      };
    });
  }

  getCustomerProducts() {
    return this.CustomerApiService.getProducts();
  }

  getTurnOverCommissionList(payload) {
    return this.AcrewardsApiService.listTurnOverCommission(payload);
  }

  getCurrentRunningCommissionList() {
    return this.AcrewardsApiService.getCurrentRunningCommission();
  }

  getPreviousRunningCommissionList() {
    return this.AcrewardsApiService.getPreviousRunningCommission();
  }

  filterAction(payload) {
    return this.AcrewardsApiService.filterTurnOverCommission(payload);
  }

}

export default AcrewardsStore;


// WEBPACK FOOTER //
// ./client/app/pages/acrewards/service/acrewards.store.js